import { render, staticRenderFns } from "./text.vue?vue&type=template&id=40ece422&"
import script from "./text.vue?vue&type=script&lang=ts&"
export * from "./text.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ece422')) {
      api.createRecord('40ece422', component.options)
    } else {
      api.reload('40ece422', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=40ece422&", function () {
      api.rerender('40ece422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/text.vue"
export default component.exports